import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, onMounted, onUnmounted } from 'vue';
  import { useTask } from '@/ui/concerns';
  import { Box, Loader } from '@/ui/components';
  import { Icon } from '@/ui/components/icon/Icon';
  import { router } from '@/ui/routes';
  import { get } from '@/services/api/resources/aiPhotoValidation';
  import { AiPhotoValidationDetail } from '@/entities/aiPhotoValidation';
  import { imageUrl } from '@/services/assets-api/assetsClient';
  import { t } from '@/ui/i18n/i18n';
  import ExpandableText from './aiPhotoValidation/ExpandableText.vue';
  import Context from '@/ui/components/analytics/detailedView/Context.vue';
  import { Button } from '@/ui/components/Button';
  import { useAiPhotoValidationHelpers } from './aiPhotoValidation/useAiPhotoValidationHelpers';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AiPhotoValidationDetailTab',
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  setup(__props) {

const props = __props;

  

  const record = ref<AiPhotoValidationDetail | null>(null);

  const getDetail = useTask(
    () => get(props.id),
    response => {
      record.value = response as AiPhotoValidationDetail;
    },
  );

  watch(() => props.id, () => {
    getDetail.run();
  }, { immediate: true });

  const previousId = computed(() => record.value?.meta?.adjacentIds?.previous_id ?? null);
  const nextId = computed(() => record.value?.meta?.adjacentIds?.next_id ?? null);

  const handleKeydown = (event: KeyboardEvent) => {
    const target = event.target as HTMLElement;
    const isInputElement = target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable;

    if (isInputElement) {
      return;
    }

    if (event.key === 'ArrowLeft' && previousId.value) {
      event.preventDefault();
      navigateToDetail(previousId.value);
    } else if (event.key === 'ArrowRight' && nextId.value) {
      event.preventDefault();
      navigateToDetail(nextId.value);
    }
  };

  onMounted(() => {
    window.addEventListener('keydown', handleKeydown);
  });

  onUnmounted(() => {
    window.removeEventListener('keydown', handleKeydown);
  });

  const imageAlt = computed(() => t('ai-photo-validation.detail.image-description'));

  const {
    formatDate,
    formatConfidence,
    getValidationResultLabel,
  } = useAiPhotoValidationHelpers();

  const navigateToDetail = (id: number) => {
    router.push({
      name: 'aiPhotoValidationDetail',
      params: { id: id.toString() },
    });
  };

  const downloadImage = () => {
    if (record.value?.data.assetId) {
      window.open(imageUrl(record.value.data.assetId), '_blank');
    }
  };

  const getValidationResultClass = (result: boolean): string => {
    return result
      ? 'ai-photo-validation-detail-tab__validation-result--positive'
      : 'ai-photo-validation-detail-tab__validation-result--negative';
  };

return { __sfc: true,props, record, getDetail, previousId, nextId, handleKeydown, imageAlt, formatDate, formatConfidence, getValidationResultLabel, navigateToDetail, downloadImage, getValidationResultClass, Box, Loader, Icon, imageUrl, ExpandableText, Context, Button }
}

})